import { setStorage } from "@/util/localStor";

/**
 * 获取下一条数据
 * @param getListApi 获取列表接口
 * @param type  查询下一条：next 或 当前条：空 （审核后当前条是否在当前搜索条件下存在）
 */
export async function getNextDataFun(self, getListApi, type) {
  if (typeof getListApi !== "function") {
    throw new Error("miss getListApi");
  }
  let query = self.$route.query?.searchObj
    ? JSON.parse(self.$route.query?.searchObj)
    : {};
  if (type === "next") {
    query.page.pageNum = query.page.pageNum + 1;
  }
  try {
    const res = await getListApi(query);
    if (res.status == 0) {
      if (res.data.records[0] && res.data.records[0].status === 0) {
        setStorage("problemData", res.data.records[0]);
        if (type === "next") {
          self.$router.replace({
            path: self.$route.path,
            query: {
              searchObj: JSON.stringify({
                ...query
              })
            }
          });
        }
        self.$router.go(0);
      } else {
        self.$message({
          type: "warning",
          message: "筛选数据已审核完！"
        });
      }
    } else {
      self.$message.error("未获取到数据，请点击返回列表");
    }
  } catch (error) {
    console.error(error);
  }
}

/**
 * 将Base64编码的字符串转换为文件对象
 * @param {string} data - Base64编码的字符串
 * @param {string} fileName - 文件名
 * @returns {File} - 返回一个文件对象
 */
export function base64toFile(data, fileName) {
  // 将Base64数据按逗号分割，获取实际的编码数据
  const dataArr = data.split(",");
  // 对Base64编码的数据进行解码
  const byteString = atob(dataArr[1]);
  // 定义文件的类型和编码方式
  const options = {
    type: "image/jpeg",
    endings: "native"
  };
  // 创建一个Uint8Array对象，用于存储解码后的数据
  const u8Arr = new Uint8Array(byteString.length);
  // 遍历解码后的数据，将每个字符的ASCII码存储到Uint8Array中
  for (let i = 0; i < byteString.length; i++) {
    u8Arr[i] = byteString.charCodeAt(i);
  }
  // 创建一个File对象，并返回
  return new File([u8Arr], fileName + ".png", options); //返回文件流
}

/**
 * 获取图片的尺寸
 * @param {File} file - 要获取尺寸的图片文件
 * @returns {Promise<{width: number, height: number}>} - 一个Promise，成功时返回包含图片宽度和高度的对象，失败时返回错误信息
 */
export function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    // 检查文件类型是否为图片
    if (!file.type.match("image.*")) {
      // 如果不是图片文件，则拒绝Promise并抛出错误
      reject(new Error("不是图片文件"));
      return;
    }

    // 创建一个新的Image对象
    const img = new Image();
    // 当图片加载成功时，执行回调函数
    img.onload = function() {
      // 解析Promise并返回图片的宽度和高度
      resolve({ width: img.width, height: img.height });
    };
    // 当图片加载失败时，执行回调函数
    img.onerror = function() {
      // 拒绝Promise并抛出错误
      reject(new Error("读取图片信息失败"));
    };
    // 使用URL.createObjectURL创建一个临时的URL，用于加载图片
    img.src = URL.createObjectURL(file); // 使用createObjectURL而不是FileReader，适用于大文件或频繁操作时提升性能和内存效率
  });
}

/**
 * 将 0 到 100 之间的数字转换为中文数字表示。
 * @param {number} num - 要转换的数字，范围在 0 到 100 之间。
 * @returns {string} - 中文数字表示，如果输入不在指定范围内则返回错误信息。
 */
export function numberToChinese(num) {
  // 检查输入的数字是否在 0 到 100 范围内
  if (num < 0 || num > 100) {
    return num;
  }
  // 定义中文数字数组
  const chineseNumbers = [
    "零",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九"
  ];
  // 处理 0 到 9 的数字
  if (num < 10) {
    return chineseNumbers[num];
  }
  // 处理数字 10
  else if (num === 10) {
    return "十";
  }
  // 处理 11 到 19 的数字
  else if (num < 20) {
    return "十" + (num % 10 === 0 ? "" : chineseNumbers[num % 10]);
  }
  // 处理 20 到 99 的数字
  else if (num < 100) {
    return (
      chineseNumbers[Math.floor(num / 10)] +
      "十" +
      (num % 10 === 0 ? "" : chineseNumbers[num % 10])
    );
  }
  // 处理数字 100
  else {
    return "一百";
  }
}
